import { render } from "./DocDisplay.vue?vue&type=template&id=c08f6968"
import script from "./DocDisplay.vue?vue&type=script&lang=js"
export * from "./DocDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__